import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import BootstrapVue from 'bootstrap-vue'
import 'element-ui/lib/theme-chalk/display.css';
import Pagination from './mixins/pagination'
import CheckNumber from './mixins/checkNumber'
import Format from './mixins/format'
import stepPointsHelper from './mixins/stepPointsHelper'
import parameters from "@/mixins/parameters";
import auth from './mixins/auth'
import templatesUtilities from './mixins/templatesUtilities'
import initObjectsHelper from './mixins/initObjectsHelper'
import GlobalEvents from 'vue-global-events'
import ToggleButton from 'vue-js-toggle-button'
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Widgets from 'fusioncharts/fusioncharts.widgets'
import i18nMixin from "@/mixins/i18nMixin";
import readOnlyMixin  from "@/mixins/readOnly";
import PaperDashboard from "./plugins/paperDashboard";

// Import the theme for FusionCharts
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'

import locale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import esLocale from 'element-ui/lib/locale/lang/es';

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.directive("el-focus", {
  inserted: function (el) {
    el.children[0].focus();
  }
});

require('es6-promise').Promise;
require('es6-promise').polyfill();

Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.component('GlobalEvents', GlobalEvents);
Vue.use(require('vue-moment'));
Vue.use(require('vue-chartist'))
Vue.use(ToggleButton)
Vue.mixin(auth);
Vue.mixin(i18nMixin);
Vue.mixin(parameters);
Vue.mixin(Pagination);
Vue.mixin(CheckNumber);
Vue.mixin(Format);
Vue.mixin(stepPointsHelper);
Vue.mixin(templatesUtilities);
Vue.mixin(initObjectsHelper);
Vue.mixin(readOnlyMixin);
Vue.use(PaperDashboard);
Vue.use(VueFusionCharts, FusionCharts, Widgets, FusionTheme);

const savedLanguage = VueCookie.get('selectedLanguage') || 'es';
locale.use(savedLanguage === 'en' ? enLocale : esLocale);
document.documentElement.lang = savedLanguage === 'en' ? 'en' : 'es';

store.watch(
  (state) => state.i18nStore.selectedLanguage,
  (newLang) => {
    locale.use(newLang === 'en' ? enLocale : esLocale);
    document.documentElement.lang = newLang === 'en' ? 'en' : 'es';
  }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
